import { COMPANY_REGIONS, DEFAULT_COMPANY_REGION } from '@shared/schema/constants.js';

const companyRegionLabels = {
  'us-west-1': 'United States — Northern California'
};

export const COMPANY_REGION_STORAGE_KEY = 'organization_region';

export const companyRegionOptions = COMPANY_REGIONS.map((region) => ({
  label: `${companyRegionLabels[region] || region} (${region})`,
  value: region
}));

export const resolveCompanyRegion = (region) => (COMPANY_REGIONS.includes(region) ? region : DEFAULT_COMPANY_REGION);
